import React from 'react';
import ReactDOM from 'react-dom'
import Highlight from 'react-highlighter';

class BrowseByDateRecordsList extends React.Component {

    constructor() {

        super();

        this.state = {
            records: [],
            filter: '',
            initialSelection: {
                id: null,
                type: null
            },
            active: null,
            year: 'all'
        };

        if (document.location.hash) {
            let hash = document.location.hash.replace(/#!?/, '').split(':');
            if (typeof hash[0] != 'undefined') {
                this.state.year = hash[0];
            }
            if (typeof hash[2] != 'undefined' && hash[2]) {
                this.state.initialSelection.id = hash[2];
                this.state.initialSelection.type = hash[1];
            }
        }
    }


    componentWillMount() {
        this._getRecords(this.state.year);
        window.highchartsCallback = (year) => {
            this._getRecords(year);
        };
    }

    componentDidUpdate() {
        if (this.state.initialSelection.id) {
            this._loadPreview(this.state.initialSelection.id, this.state.initialSelection.type);
            this.setState({initialSelection: {id: null}});
        }
    }

    render() {

        let scope = this;
        let regex;
        let highlight;
        let className;

        if (scope.state.filter  && (scope.state.filter.length >= 3 || scope.state.records.length <= 300)) {
            regex = new RegExp(this.state.filter, 'i');
        }

        let browseByHeading = '';

        if (scope.state.records.length) {
            browseByHeading += 'Available Resources';
            if (scope.state.year === 'all') {
                browseByHeading += ' from all years';
            } else {
                browseByHeading += ' from '+scope.state.year;
            }
            browseByHeading += ' (showing '+scope.state.records.length+')';
        }

        return (
            <div>
                <div className="row browse-by-header">
                    <div className="col-12 col-lg-7">{browseByHeading}</div>
                    <div className="d-none d-lg-block col-lg-5">Resource Details</div>
                </div>
                <div className="row">

                    <div className="col-12 col-sm-12 col-lg-7 browse-by-left" id="list-container">

                        <div className="list-search-container" style={{padding:'10px'}}>
                            <input className="list-search form-control input-sm"
                                   placeholder="Filter items by title ..."
                                   onChange={scope._filterItems.bind(scope)} />
                        </div>

                        <p className="text-center loading-resources">
                            <br />
                            <i className="fa fa-spinner fa-spin fa-2x"></i>
                        </p>
                        <ul className="browse-by-list" ref="browseByList">
                            {this.state.records.map(function(row, i) {

                                // check over searchable values array
                                const match_found = (searchable_values) => {
                                    return searchable_values.filter((elem) => {
                                        return elem.match(regex);
                                    }).length > 0;
                                }

                                if (regex && !row.formatted_title.match(regex)) {
                                    const exist_match = row.metadata.searchable_values !== undefined ? match_found(row.metadata.searchable_values) : false;
                                    if (exist_match === false) {
                                        return false;
                                    }
                                }

                                className = scope.state.active == row.content_type + row.id ? 'active' : '';

                                if (scope.state.filter  && (scope.state.filter.length >= 3 || scope.state.records.length <= 300)) {
                                    highlight =
                                        <span onClick={scope._loadPreview.bind(scope, row.title_id, row.content_type)}>
                                            <Highlight
                                                matchClass="highlighted"
                                                search={scope.state.filter}
                                                key="{i}">
                                                    {row.formatted_title}
                                            </Highlight>
                                        </span>;
                                } else {
                                    highlight =
                                        <span onClick={scope._loadPreview.bind(scope, row.title_id, row.content_type)}>
                                            {row.formatted_title}
                                        </span>;
                                }

                                return (
                                    <li key={i} className={className} ref={row.id}>
                                        {highlight}
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                    <div className="d-none d-lg-block col-lg-5 browse-by-right">
                        <div className="instructions-text">
                            <div className="instructions-text-arrow pull-left"></div>
                            <div style={{paddingTop: '10%'}}>Select a resource to view.</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _getRecords(year) {
        document.location.hash = year;
        $('.loading-resources').show();
        this.setState({records: []});
        jQuery.getJSON({
            url: document.location.pathname + '?ajax=1&year='+year,
            success: (result) => {
                $('.loading-resources').hide();
                this.setState({
                    records: result.records,
                    year: year
                });
                window.years = year;
            }
        });
    }

    _filterItems(event) {
        this.setState({
            filter: event.target.value
        });
    }

    _loadPreview(id, type) {
        document.location.hash = this.state.year+':'+type+':'+id;

        this.setState({active: type+id});

        if ($('.browse-by-right').is(':visible')) {
            $('.browse-by-right')
                .html('<p class="text-center"><br><i class="fa fa-spinner fa-spin fa-2x"></i>')
                .show();
        } else {
            $('.loading').show();
        }

        jQuery.get('/'+type+'/'+id+'?ajax=1', function(resourceDetails) {
            // if desktop, right column will be visible, show details there
            if ($('.browse-by-right').is(':visible')) {
                $('.browse-by-right').html(resourceDetails);
                // highlight item
                $(this).parent().addClass('active');
                // if mobile or tablet, show details in modal
            } else {
                $('.browse-by-modal').find('.modal-body').html(resourceDetails);
                var contentBtns = $('.browse-by-modal').find('.modal-body').find('.btn-success'),
                    footerBtns = $('.browse-by-modal').find('.modal-footer').find('.footer-buttons'),
                    contentTitle = $('.browse-by-modal').find('.recordviewlink'),
                    modalTitle = $('.browse-by-modal').find('.modal-title');
                footerBtns.empty().append(contentBtns.clone());
                contentBtns.hide();
                modalTitle.text(contentTitle.text());
                contentTitle.parent().hide();
                $('.browse-by-modal').modal('show');
                $('.loading').hide();
            }
        });
    }
}

ReactDOM.render(
    <BrowseByDateRecordsList />, document.getElementById('records')
);
